import { styled } from '@mui/material'

export const TextsContainer = styled('div')`
  display: flex;
  p {
    line-height: 20px;
    color: #4f4848;
    font-size: 20px;
  }
`

export const StyledForm = styled('form')`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-decoration: none;
  color: #111;
`
